<template>
  <section id="portal-promotions" class="promotions-grid">
    <div v-if="headingKey" class="promotions-grid__header d-flex align-items-center justify-content-between">
      <div class="promotions-grid__heading-wrap">
        <h2 class="promotions-grid__heading">
          {{ $t(headingKey) }}
        </h2>
        <router-link
          v-if="showViewAllLink"
          class="promotions-grid__all-link"
          :to="{ name: 'portalPromotions' }"
        >
          {{ $t("portalHome.promotions.viewAll") }}
        </router-link>
      </div>

      <div
        v-if="showFilters"
        class="promotions-grid__filters"
        role="tablist"
        :aria-label="$t('portalHome.promotions.filtersAriaLabel')"
      >
        <button
          v-for="filter in filterOptions"
          :key="filter.id"
          type="button"
          class="promotions-grid__filter"
          :class="{ 'promotions-grid__filter--active': activeFilter === filter.id }"
          role="tab"
          :aria-selected="activeFilter === filter.id"
          @click="$emit('update:activeFilter', filter.id)"
        >
          {{ $t(filter.labelKey) }}
        </button>
      </div>

      <button
        v-else-if="showViewToggle"
        class="promotions-grid__view-toggle"
        type="button"
        :aria-pressed="isSliderView"
        @click="isSliderView = !isSliderView"
      >
        {{ isSliderView ? $t("portalHome.promotions.listView") : $t("portalHome.promotions.sliderView") }}
      </button>
    </div>
    <div
      class="promotions-grid__grid"
      :class="{ 'promotions-grid__grid--slider': isSliderView }"
    >
      <PromotionCard
        v-for="promotion in promotions"
        :key="promotion.id"
        :promotion="promotion"
        :signing-in="signingInPromotionId === promotion.id"
        @sign-in="$emit('sign-in', $event)"
      />
    </div>
  </section>
</template>

<script setup>
import PromotionCard from "./PromotionCard.vue";
import { defineEmits, defineProps, ref } from "vue";

defineEmits(["sign-in", "update:activeFilter"]);

defineProps({
  promotions: { type: Array, required: true },
  signingInPromotionId: {
    type: [Number, String],
    default: null,
  },
  headingKey: {
    type: String,
    default: "portalHome.promotions.heading",
  },
  showViewAllLink: {
    type: Boolean,
    default: false,
  },
  showViewToggle: {
    type: Boolean,
    default: true,
  },
  showFilters: {
    type: Boolean,
    default: false,
  },
  activeFilter: {
    type: String,
    default: "all",
  },
});

const filterOptions = [
  { id: "all", labelKey: "portalHome.promotions.filterAll" },
  { id: "active", labelKey: "portalHome.promotions.filterActive" },
  { id: "sign_in_required", labelKey: "portalHome.promotions.filterSignInRequired" },
  { id: "signed", labelKey: "portalHome.promotions.filterSigned" },
];

const isSliderView = ref(false);
</script>

<style scoped lang="scss">
@import "@/styles/portal-home/promotions-grid";
</style>
